/* ===========================================================================
   HEYBABE Atelier — reveal
   Scroll-triggered entrance. Opacity and transform only, so it stays on the
   compositor. One observer for the whole page, not one per element.

   Elements opt in with data-reveal and optionally data-reveal-delay.
   Nothing is hidden unless .hb-motion-ready is on the document, which
   motion.core.js adds only when motion is both enabled and permitted.
   =========================================================================== */

(function () {
  'use strict';

  var Motion = window.HBMotion;
  if (!Motion || !Motion.enabled) return;
  if (Motion.reduced) return;
  if (!document.documentElement.classList.contains('hb-motion-ready')) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTOR = '[data-reveal]';

  function reveal(el) {
    el.classList.add('is-revealed');
    el.removeAttribute('data-reveal');
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
      if (delay > 0) window.setTimeout(function () { reveal(el); }, delay);
      else reveal(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  /* Atelier frame: one shared reveal for editorial plates and the kombin pair.
     The state class only starts a CSS animation; nothing is measured per frame. */
  var FRAME = '[data-frame]';
  var frameIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      frameIo.unobserve(entry.target);
      entry.target.classList.add('is-framed');
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.18 });

  function scanFrames() {
    var nodes = document.querySelectorAll(FRAME + ':not(.is-framed)');
    for (var i = 0; i < nodes.length; i++) frameIo.observe(nodes[i]);
  }

  scan();
  scanFrames();
  document.addEventListener('shopify:section:load', function () { scan(); scanFrames(); });

  /* Safety net: anything still unrevealed after 3s in view is shown anyway.
     A stuck invisible card is a worse failure than a missing animation. */
  window.setTimeout(function () {
    var stuck = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < stuck.length; i++) {
      var r = stuck[i].getBoundingClientRect();
      if (r.top < window.innerHeight) reveal(stuck[i]);
    }
    var frames = document.querySelectorAll(FRAME + ':not(.is-framed)');
    for (var j = 0; j < frames.length; j++) {
      var fr = frames[j].getBoundingClientRect();
      if (fr.top < window.innerHeight * 0.8 && fr.bottom > 0) frames[j].classList.add('is-framed');
    }
  }, 3000);
})();
